var map = {
	"./de/mechaName.png": "bE0Z",
	"./en/mechaName.png": "Iegt",
	"./es/mechaName.png": "hkJg",
	"./fr/mechaName.png": "akjy",
	"./ja/mechaName.png": "zdSh",
	"./ko/mechaName.png": "QMhu",
	"./pt/mechaName.png": "I6FF",
	"./ru/mechaName.png": "hz9x",
	"./tc/mechaName.png": "N8d4",
	"./th/mechaName.png": "S/Cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2PAJ";